import React from 'react'

function LoginHolder({ children }) {
  return <div
    className="row col-10 my-4 p-4 bg-white shadow-sm"
    style={{ margin: 'auto' }}>
    <div className="row col-12 align-items-center">
      <div className="col-6 mr-4">
        <div className="app-welcome-title color-blue">Welcome</div>
        <div className="font-lg color-dark-grey" style={{ lineHeight: '1.6' }}>
          The <span className="font-bold">Portal</span> application allows CTSU
          users to login using their CTEP-IAM account to view information,
          updates, and access the CTSU suite of applications.
        </div>
      </div>
      <div className="col-6 align-center ctep-login-wrapper">
        <div className="content-page-title color-dark-blue">CTEP-IAM Login</div>
        <div className="iframe-container">{children}</div>
      </div>
    </div>
  </div>
}

export default LoginHolder
